cv.PublicTeamsView = Marionette.CompositeView.extend({
  template : cv.Templates['public/teams/teams'],
  childViewContainer: '.teams-list',
  childView: cv.PublicTeamsRowView,
  emptyView: cv.PublicTeamsRowEmptyView,

  events: {
  },

  behaviors: [{
    behaviorClass: cv.PaginatePublicBehavior
  }],

  childEvents: {
    'show' : function() {
    },
    'render' : function() {
    }
  },

  childViewOptions: function(model, index) {
    // do some calculations based on the model
    return {
      // Pass the current tab
    }
  },

  initialize: function(options){
    this.mergeOptions(options, this.options);

    console.log('PublicTeamsView initialized');
  },

  isEmpty: function(collection){
    console.log(collection);
    if(collection.num_records > 0 || _.isUndefined(collection.num_records)){
      return false;
    }
    if(collection.num_records == 0){
      this.$('.pagination').remove();
      return true;
    }
  },

  attachHtml: function(collectionView, childView, index){
    if (collectionView.isBuffering) {
      // buffering happens on reset events and initial renders
      // in order to reduce the number of inserts into the
      // document, which are expensive.
      collectionView._bufferedChildren.splice(index, 0, childView);
    }else {
      // If we've already rendered the main collection, append
      // the new child into the correct order if we need to. Otherwise
      // append to the end.
      if (!collectionView._insertBefore(childView, index)){
        collectionView._insertAfter(childView);
      }
    }
  },

  templateHelpers: function(){
    return {
      heading : this.options.heading,
      subtitle : this.options.subheading
    }
  },

  onBeforeShow: function(){
  },

  onShow: function(){
    if(cv.PRELOADED.preview == true){
      this.$('.teams-list').html(cv.Templates['public/teams/preview']({
        items : [1,2,3]
      }));
    }else{
      this.collection.fetch({
        reset: true
      });
    }
  },

  onDestroy: function(){
  }
});
